import React from 'react';
import PropTypes from 'prop-types';
import { urlParams } from 'utils/request';
import ConnectionSchedulerView from './ConnectionSchedulerView';
import { SFEntityID, starfishMediaType, SFNotification } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import { withNotification } from 'common/withNotification';

class ConnectionSchedulerContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      connection: null,
      hasFetched: false
    };
  }

  componentDidMount() {
    const { id, serviceId } = this.props;
    const URL = `../api/starfish/success-network/connections/${id}` + (serviceId ? `?${urlParams({serviceId: serviceId})}` : '');
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('successnetwork')
      }
    })
    .then(connection => this.setState({connection}))
    .catch(e => this.props.notification.error(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <ConnectionSchedulerView
        {...this.state}
        partyId={this.props.partyId}
        uuid={this.props.uuid}
        notification={this.props.notification}
        userTimeZone={this.props.userTimeZone}
      />
    );
  }
}

ConnectionSchedulerContainer.propTypes = {
  id: SFEntityID.isRequired,
  uuid: PropTypes.string.isRequired,
  partyId: SFEntityID.isRequired,
  notification: SFNotification.isRequired,
  userTimeZone: PropTypes.string.isRequired,
  serviceId: PropTypes.string
};

export default withNotification(ConnectionSchedulerContainer);
